
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 29.2 50.96"}, attrs),
              ...rest,
            },
            children.concat([_c('title',[_v('mobile')]),_c('g',{attrs:{"id":"Layer_2","data-name":"Layer 2"}},[_c('g',{attrs:{"id":"Layer_1-2","data-name":"Layer 1"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M0,25.45C0,18.53.09,11.6,0,4.68A4.4,4.4,0,0,1,4.66,0C11.45.07,18.24,0,25,0A4.19,4.19,0,0,1,29.19,4c0,.25,0,.49,0,.73v41.6c0,3-1.69,4.67-4.65,4.67h-20A4.19,4.19,0,0,1,0,46.41ZM3.55,10.37V40.55H25.68V10.37ZM14.6,4.53H11.08c-.48,0-.93.08-.92.68s.43.65.89.65h7c.48,0,.95-.07,1-.65s-.44-.68-.93-.68Zm0,39.59a1.66,1.66,0,0,0,0,3.31,1.68,1.68,0,0,0,1.68-1.7A1.7,1.7,0,0,0,14.56,44.12Z"}})])])])
          )
        }
      }
    